import { React, useState, useEffect, View, useRef } from 'react';
import { Button, Modal } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
//import { auth } from '../firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import BottomTabNavigation from './BottomTabNavigation';
import Konsensus_Constants from '../constants/index.js';
import { Paper, Stack, Box } from "@mui/material";
import NewPostModal from './NewPostModal';
import axios from "axios";
import { useParams } from "react-router-dom";
import { COLORS, SIZES, FONTS, images } from '../constants'
import DOMPurify from "dompurify";
import he from "he";


export default function ConversationDetail() {
  const { notificationId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const scrollViewRef = useRef(null);

  const checkLogin = async() => {
    if( window.location.href!='https://app.konsensus.tech/' && window.location.href!='https://app.dev.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/' && window.location.href!='https://app.accept.konsensus.tech/register' && window.location.href!='https://app.accept.konsensus.tech/forgotten_password'){
        try{
            let login_data = await Konsensus_Constants._retrieveDataLocal("login_response");
            // console.log("Checking login: "+JSON.stringify(login_data));
            if( login_data.login_response.data ){
                let res = await fetch(Konsensus_Constants.FORUM_URL+'/api/users?filter[self]=1&userId='+login_data.login_response.data.userId, {
                  headers: { 'Authorization': 'Token '+login_data.login_response.data.token }
                });
                // console.log(res);
                if (res.status !== 200) {
                  //alert('Session expired!');
                  navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
                }
            }else{
              navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
            }
        } catch (error) {
          console.error(error);
          navigate('/', { state: { message: "Either your login has expired or you haven't confirmed e-mail yet!" } });
        }
    }
    console.log(window.location.href);
  }

  setInterval(async () => {
    checkLogin();
  }, 5 * 60 * 1000); // every 5 minutes

  useEffect(() => {
    fetchData();
    checkLogin();
    updateViewLoadNotifications();
  }, [notificationId]);


  const updateViewLoadNotifications = async () => {
    const AXIOS_CONFIG = {
        headers: {
            'Content-Type':'application/json'
        }
    }
    axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/set-notification-viewed', {notificationId: notificationId}, AXIOS_CONFIG);
    let nem = await Konsensus_Constants._retrieveDataLocal("nem");
    console.log(nem.nem.data.session_id);
    let response3 = await axios.post(Konsensus_Constants.NEM_URL+'/NEM/api/api.php/notifications', {userhash: nem.nem.data.userhash}, AXIOS_CONFIG);
    if( response3.data.error ){
       alert(response3.data.error);
    }else{
       console.log(response3);
       Konsensus_Constants._storeData("nem_notifications",response3);
    }
  }
    const fetchData = async () => {
      try {
        let login_data = await Konsensus_Constants._retrieveDataLocal("login_response")
        let notifications = await Konsensus_Constants._retrieveDataLocal("nem_notifications");
        for( var i=0; i<=notifications.nem_notifications.data.data.length; i++ ){
            if( notifications.nem_notifications.data.data[i].id == notificationId ){
                setNotification(notifications.nem_notifications.data.data[i]);
            }
        }
      } catch (error) {
        console.error(error);
      }
    };

  if (!notification){
       return (
         <div className="root-loading-overlay" style={styles.rootLoadingOverlay}>
           <div className="spinner" style={styles.spinner}><div><CircularProgress sx={{ color: '#00aaaf' }} style={{width:100, height:100,}}/></div></div>
         </div>
       );
  }

    // 1. Allow the target attribute globally
    DOMPurify.setConfig({
      ADD_ATTR: ["target"]
    });

    // 2. Add the hook to always allow all target values
    DOMPurify.addHook('uponSanitizeElement', (node, data) => {
      if (data.tagName === 'a' && node.hasAttribute('target')) {
        const target = node.getAttribute('target');
        node.setAttribute('target', target); // Accept all targets
        // Security: add rel for _blank
        if (target === '_blank' && !node.hasAttribute('rel')) {
          node.setAttribute('rel', 'noopener noreferrer');
        }
      }
    });

  function RawHTMLExample({ htmlString }) {
    const cleanHtml = DOMPurify.sanitize(he.decode(htmlString));
    return <div style={styles.postMeta2} dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
  }

  return (
    <Box sx={{
                 height: "100vh", // Fill viewport height
                 display: "flex",
                 flexDirection: "column",
               }}>
       <Paper elevation={3} sx={{ p: 2 }}>
           <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
             <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
               <img src={require('../assets/images/banner.png')}
                             style={{
                              height: 97,
                              width: 380,
                              marginBottom: 0,
                              marginTop: 20,
                             }}/>
             </div>
             <div style={{ display: 'flex', gap: 8 }}>
             </div>
           </div>
       </Paper>
      <Paper elevation={3}
                     sx={{
                       flex: 1,        // fill all available vertical space
                       width: "100%",  // fill horizontal space
                       p: 2,
                     }}>
            <div style={styles.container}>
                      <div ref={scrollViewRef} style={styles.container}>
                        <div style={{
                            fontSize: 24, fontWeight: 'bold', marginBottom: 8, color: "#00aaaf"
                          }} className="title"><RawHTMLExample htmlString={notification.title || ''} /></div>
                        <div style={styles.postMeta}><RawHTMLExample htmlString={notification.html_content || ''} /></div>
                      </div>
             </div>
      </Paper>
      <BottomTabNavigation />
    </Box>
  );
}
const styles = {
  container: { padding: 16, paddingTop:10, flex: 1 },
  title: { fontSize: 24, fontWeight: 'bold', marginBottom: 8, color: COLORS.primary },
  commentCount: { fontSize: 16, marginBottom: 14 },
  postsContainer: { marginTop: 10 },
  post: { marginBottom: 22 },
  userContainer: { flexDirection: 'row', alignItems: 'center', marginBottom: 4 },
  avatar: { width: 36, height: 36, borderRadius: 18, marginRight: 10, backgroundColor: '#e7f4f6', float: "left", display: 'flex', alignItems: 'center', justifyContent: 'center',},
  avatarPlaceholder: { backgroundColor: '#e7f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#00aaaf', },
  userInfo: { flexDirection: 'column' },
  username: { fontSize: 16, fontWeight: '600', color: '#00aaaf' },
  postMeta: { fontSize: 12, color: '#888' },
  postMeta2: { fontSize: 14, color: '#282828' },
  hr: { height: 1, backgroundColor: '#ddd', marginTop: 8, marginBottom: 4 },
  error: { fontSize: 18, color: 'red', padding: 16 },
      btn: {
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'row',
          backgroundColor: COLORS.primary,
          width: 300,
          paddingVertical: SIZES.padding * 2,
      },
      btnText: {
          ...FONTS.body3,
          color: COLORS.white,
          marginLeft: 8,
      },
    rootLoadingOverlay: {
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#fffk",
      zIndex: "9999k",
    },
    spinner: {
      fontSize: "2rem",
      fontWeight: "bold",
      color: "#00aaaf",
    },
};